import {createFetchResourceAction} from 'src/shared/utils/resource';
import {token} from 'src/shared/auth/selectors';
import {AUTH} from 'src/shared/auth/actions';
import {LOAD_USER_COMPLETE} from 'src/shared/user/actions';
import {formatPhoneNumber} from 'src/shared/utils/formatPhoneNumber';
import {requiresAccountNumber} from 'src/shared/utils/resourcePrequisites';

import {
  deleteInteraction as deleteInteractionURL,
  scheduleCallbacks,
  scheduleAsapCallbacks,
} from 'src/shared/config/urls';
export const LOAD_INTERACTIONS_START = 'LOAD_INTERACTIONS_START';
export const LOAD_INTERACTIONS_SUCCESS = 'LOAD_INTERACTIONS_SUCCESS';
export const LOAD_INTERACTIONS_ERROR = 'LOAD_INTERACTIONS_ERROR';
export const LOAD_INTERACTIONS_COMPLETE = 'LOAD_INTERACTIONS_COMPLETE';

export const loadInteractions = () => createFetchResourceAction({
  start: LOAD_INTERACTIONS_START,
  success: LOAD_INTERACTIONS_SUCCESS,
  error: LOAD_INTERACTIONS_ERROR,
  complete: LOAD_INTERACTIONS_COMPLETE,
  waitUntil: [AUTH, LOAD_USER_COMPLETE],
  qualify: requiresAccountNumber,
  url: scheduleCallbacks,
  token,
  postProcess: json => json.interactions,
});

export const DELETE_INTERACTION_START = 'DELETE_INTERACTION_START';
export const DELETE_INTERACTION_SUCCESS = 'DELETE_INTERACTION_SUCCESS';
export const DELETE_INTERACTION_ERROR = 'DELETE_INTERACTION_ERROR';
export const DELETE_INTERACTION_COMPLETE = 'DELETE_INTERACTION_COMPLETE';

export const deleteInteraction = appointmentId => createFetchResourceAction({
  start: DELETE_INTERACTION_START,
  success: DELETE_INTERACTION_SUCCESS,
  error: DELETE_INTERACTION_ERROR,
  complete: DELETE_INTERACTION_COMPLETE,
  waitUntil: [AUTH, LOAD_USER_COMPLETE],
  qualify: requiresAccountNumber,
  url: state => deleteInteractionURL(state, appointmentId),
  token,
  fetchOptions: {method: 'DELETE'},
});

export const CREATE_INTERACTION_START = 'CREATE_INTERACTION_START';
export const CREATE_INTERACTION_SUCCESS = 'CREATE_INTERACTION_SUCCESS';
export const CREATE_INTERACTION_ERROR = 'CREATE_INTERACTION_ERROR';
export const CREATE_INTERACTION_COMPLETE = 'CREATE_INTERACTION_COMPLETE';

/**
 * @function formatWithTimeZone - Returns ISO formatted date with customer's time zone information.
 * @param {string} timeslot - timeslot from the state
 * @returns {string}
 */
const formatTimeWithTimeZone = timeslot => {
  const slotDate = new Date(timeslot);
  const offset = slotDate.getTimezoneOffset(); // amount in minutes
  const absoluteOffset = Math.abs(offset);
  const date = new Date(slotDate.getTime() - offset * 60 * 1000).toISOString().substr(0, 19);
  const timeZoneSymbol = offset > 0 ? '-' : '+';
  const timeZoneHours = Math.floor(absoluteOffset / 60).toFixed(0).padStart(2, '0');
  const timeZoneMinutes = (absoluteOffset % 60).toString().padStart(2, '0');
  return `${date}${timeZoneSymbol}${timeZoneHours}:${timeZoneMinutes}`;
};

export const createInteraction = ({phone, intent, email, timeslot, appContext}) =>

  createFetchResourceAction({
    start: CREATE_INTERACTION_START,
    success: CREATE_INTERACTION_SUCCESS,
    error: CREATE_INTERACTION_ERROR,
    complete: CREATE_INTERACTION_COMPLETE,
    waitUntil: [AUTH, LOAD_USER_COMPLETE],
    qualify: requiresAccountNumber,
    url: timeslot === 'IMMEDIATE' ? scheduleAsapCallbacks : scheduleCallbacks,
    token,
    fetchOptions: {
      method: 'POST',
      body: JSON.stringify({
      // no milliseconds
        intent,
        phone: formatPhoneNumber(phone, false),
        // Conditionally include time and email based on enableAsapCall
        ...(timeslot !== 'IMMEDIATE' && {
          time: formatTimeWithTimeZone(timeslot),
          email,
        }),
        ...(appContext && {appContext}), // optional parameter
      }),
      headers: {'Content-Type': 'application/json'},
    },
    postProcess: json => {
      const interaction = {...json};
      if (!interaction.email && email) {
        interaction.email = email;
      }
      return interaction;
    },
  });
